<template>
  <esg-base-dashboard-card title="평가 매트릭스" id="esg-partner-evaluation-matrix">
    <div class="my-3">
      <apex-chart type="radar" width="450" :options="chartOptions" :series="series"></apex-chart>
    </div>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";

export default {
  components: { EsgBaseDashboardCard },
  data() {
    return {
      series: [{
        name: '',
        data: [180, 150, 130, 140, 100, 99],
        // data: ['Leader', 'Leader', 'Leader', 'Leader', 'Laggard', 'Average'],
      }],
      chartOptions: {
        chart: {
          type: 'radar',
          toolbar: {
            show: false
          }
        },
        grid: {
          padding: {
            top: -35,
            bottom: -50,
          }
        },
        xaxis: {
          categories: [
            'E(환경)',
            'S(안전)',
            'S(사회)',
            'S(윤리)',
            'G(경제)',
            'G(경영시스템)'
          ],
          labels: {
            show: true,
            style: {
              colors: ["#a8a8a8"],
              fontSize: "12px",
              fontFamily: 'Arial',
            }
          },
        },
        responsive: [
          {
            breakpoint: 576,
            options: {
              chart: { width: 350 },
              legend: { position: 'bottom' }
            }
          }
        ],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            let level = ''
            if (val > 150) {
              level = 'Leader'
            } else if (val > 100) {
              level = 'Average'
            } else {
              level = 'Laggard'
            }

            return level;
          }
        },
      },
    }
  }
}
</script>

<style scoped></style>